export default {"src":"/_next/static/media/icon_nav_dd_docs_on.f4164299.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};